var render = function render(_c,_vm){return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_c('th',{staticClass:"text-left"},[_vm._v(" 序号 ")]),_vm._t("default"),_c('th',{staticClass:"text-right"},[_vm._v(" 操作 ")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }